const Reducers = {
  AUTH: 'auth',
  BID_LIST: 'bidList',
  DISCLOSURE_COUNT: 'disclosureCount',
  FILTER: 'filter',
  LAYOUT: 'layout',
  LIVE_BIDS: 'liveBids',
  MANUFACTURER_LIST: 'manufacturerList',
  MEDIA_METADATA: 'mediaMetadata',
  NEGOTIATION_CHANGE: 'negotiationChange',
  ORGANIZATION_DEALER: 'organizationDealer',
  PENDING_STATE: 'pendingState',
  PROXY_BIDS: 'proxyBids', // OMP Only
  SSE_CONNECTION_STATUS: 'sseConnectionStatus',
  STATE_CHANGE: 'stateChange',
  TRADE_CHANGE: 'tradeChange',
  TRADE_DETAILS: 'tradeDetails',
  TRADE_LIST: 'tradeList',
  UI: 'ui',
  USER_DETAILS: 'userDetails',
  VDP: 'vdp',
  BIDDING_DATA: 'biddingData' // OMP Only
};

export default Reducers;
